interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | '...')[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (page > 3) pages.push('...');
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) pages.push(i);
    if (page < totalPages - 2) pages.push('...');
    pages.push(totalPages);
  }

  const btnStyle = (active: boolean, disabled?: boolean): React.CSSProperties => ({
    padding: '0.3rem 0.65rem',
    borderRadius: 6,
    border: active ? '2px solid var(--primary)' : '1px solid var(--border)',
    background: active ? 'var(--primary)' : disabled ? 'var(--surface)' : 'white',
    color: active ? 'white' : disabled ? 'var(--text-muted)' : 'var(--text)',
    fontWeight: active ? 700 : 400,
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: '0.85rem',
    lineHeight: 1.4,
    opacity: disabled ? 0.5 : 1,
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.3rem', padding: '1rem 0 0.25rem' }}>
      <button
        style={btnStyle(false, page === 1)}
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
      >
        Prev
      </button>
      {pages.map((p, i) =>
        p === '...' ? (
          <span key={`ellipsis-${i}`} style={{ padding: '0.3rem 0.4rem', color: 'var(--text-muted)', fontSize: '0.85rem' }}>…</span>
        ) : (
          <button
            key={p}
            style={btnStyle(p === page)}
            onClick={() => onChange(p)}
          >
            {p}
          </button>
        )
      )}
      <button
        style={btnStyle(false, page === totalPages)}
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
      >
        Next
      </button>
    </div>
  );
}
